import template from "./scenes-list.html";
import controller from "./scenes-list.controller";
import "./scenes-list.scss";

const ScenesListComponent = {
    template,
    controller,
    controllerAs: "ctrl",
    bindings: {
        model: "=",
        company: "<",
        single: "<",
        gif: "<",
        boomerang: "<",
        video: "<",
        hideBg: "<",
        aiFeature: "<",
        unscreenIsActive: "<",
        aiBackground: "<",
        aiOverlay: "<",
        newDesign: "<",
        activeFeatures: "<",
        activeModes: "<",
        promptingEnabled: "<",
        promptingQuality: "<"
    }
};

export default ScenesListComponent;



// WEBPACK FOOTER //
// ./sources/components/configurations/scenes-list/scenes-list.component.js